import React from 'react';
import HashtagDisplay from './HashtagDisplay';
import PoliticalLeaningBadge from './PoliticalLeaningBadge';

const MeetingItem = ({ meeting, isSelected, onClick, onHashtagClick, agendaItems = [] }) => {
  // Format the date nicely
  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Calculate average leaning score for this meeting's agenda items
  const calculateAverageLeaningScore = () => {
    const meetingAgendaItems = agendaItems.filter(item => item.meeting_id === meeting.id);
    const validScores = meetingAgendaItems
      .map(item => item.leaning_score)
      .filter(score => score !== null && score !== undefined);
    
    if (validScores.length === 0) return null;
    
    const sum = validScores.reduce((acc, score) => acc + score, 0);
    return sum / validScores.length;
  };

  // Calculate most used hashtags from agenda items for this meeting
  const getMostUsedHashtagsFromAgendaItems = () => {
    const meetingAgendaItems = agendaItems.filter(item => item.meeting_id === meeting.id);
    const hashtagCounts = {};
    
    // Count hashtags from all agenda items in this meeting
    meetingAgendaItems.forEach(item => {
      if (item.hashtags && Array.isArray(item.hashtags)) {
        item.hashtags.forEach(hashtag => {
          hashtagCounts[hashtag] = (hashtagCounts[hashtag] || 0) + 1;
        });
      }
    });
    
    // Sort by count and return top hashtags
    return Object.entries(hashtagCounts)
      .sort(([,a], [,b]) => b - a)
      .slice(0, 6) // Show top 6 hashtags
      .map(([hashtag]) => hashtag);
  };

  const averageLeaningScore = calculateAverageLeaningScore();
  const topHashtags = getMostUsedHashtagsFromAgendaItems();

  return (
    <div 
      className={`p-4 px-5 border-b border-gray-200 dark:border-gray-700 transition hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer ${isSelected ? 'bg-primary/10 dark:bg-primary/20 border-l-3 border-primary' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className="inline-flex items-center justify-center py-1 px-3 text-xs font-medium rounded-full uppercase tracking-wider bg-dark dark:bg-gray-600 text-white mr-3">
          {meeting.meeting_number}
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-medium text-gray-900 dark:text-white">
              {meeting.parliamentary_session ? 
                `${meeting.parliamentary_session} Session` : 
                `Meeting ${meeting.meeting_number}`
              }
            </h3>
            <PoliticalLeaningBadge leaningScore={averageLeaningScore} />
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {formatDate(meeting.date_of_sitting)}
          </p>
          {meeting.location && (
            <p className="text-xs text-gray-400 dark:text-gray-500">{meeting.location}</p>
          )}
          <HashtagDisplay 
            hashtags={topHashtags} 
            className="mt-2" 
            onHashtagClick={onHashtagClick}
          />
        </div>
      </div>
    </div>
  );
};

export default MeetingItem;
